// Translation dictionaries for FLEX ENERGY dashboards.
// Keep keys in dot-notation: "scope.subscope.label".
// Dynamic data (client names, plan names, emails) is NEVER translated here.

export const TRANSLATIONS = {
  es: {
    // Common
    "common.cancel": "Cancelar",
    "common.save": "Guardar",
    "common.saving": "Guardando...",
    "common.confirm": "Confirmar",
    "common.delete": "Eliminar",
    "common.edit": "Editar",
    "common.search": "Buscar",
    "common.loading": "Cargando...",
    "common.error": "Algo salió mal. Intenta de nuevo.",
    "common.empty": "Sin resultados",
    "common.workspace": "Workspace",
    "common.actions": "Acciones",
    "common.status": "Estado",
    "common.reason": "Motivo",
    "common.notes": "Notas",
    "common.required": "Requerido",
    "common.optional": "Opcional",
    "common.client": "Cliente",
    "common.clients": "Clientes",
    "common.amount": "Monto",
    "common.date": "Fecha",
    "common.theme.dark": "Modo oscuro",
    "common.theme.light": "Modo claro",
    "common.language": "Idioma",

    // Brand
    "brand.financial": "Financial",
    "brand.support": "Support",
    "brand.texas": "Texas · Support",

    // Sidebar groups (Financial)
    "nav.group.general": "General",
    "nav.group.panel": "Panel",
    "nav.group.clients": "Clientes",
    "nav.group.operation": "Operaciones",
    "nav.group.finance": "Finanzas",
    "nav.group.communication": "Comunicación",
    "nav.group.system": "Sistema",
    "nav.group.admin": "Administración",
    "nav.group.session": "Sesión",

    // Sidebar items (Financial)
    "nav.dashboard": "Dashboard",
    "nav.newConnection": "Nueva conexión",
    "nav.clients": "Clientes activos",
    "nav.clients.pending": "Pendientes de activación",
    "nav.clients.disconnected": "Clientes desconectados",
    "nav.clients.reconnect": "Pendiente reconexión",
    "nav.invoices": "Facturas",
    "nav.calendar": "Calendario",
    "nav.accounting": "Contabilidad",
    "nav.reports": "Reportes",
    "nav.payouts": "Pagos por referido",
    "nav.plans": "Planes",
    "nav.communications": "Centro de comunicación",
    "nav.activity": "Actividad",
    "nav.admins": "Administradores",
    "nav.changePassword": "Cambiar contraseña",
    "nav.logout": "Cerrar sesión",

    "pwd.title": "Cambiar contraseña",
    "pwd.current": "Contraseña actual",
    "pwd.new": "Nueva contraseña",
    "pwd.confirm": "Confirmar nueva",
    "pwd.hint": "Mínimo 8 caracteres. Diferente a la actual.",
    "pwd.mismatch": "Las contraseñas no coinciden",
    "pwd.tooShort": "Mínimo 8 caracteres",
    "pwd.success": "Contraseña actualizada",
    "pwd.submit": "Actualizar",

    // Sidebar items (Support)
    "snav.group.operations": "Operaciones",
    "snav.group.clients": "Clientes",
    "snav.group.catalog": "Catálogo",
    "snav.group.team": "Equipo",
    "snav.group.administration": "Administración",
    "snav.orders": "Nuevas órdenes",
    "snav.leads": "Leads asignados",
    "snav.active": "Activos",
    "snav.disconnected": "Desconectados",
    "snav.transferred": "Trasladados",
    "snav.lost": "Leads perdidos",
    "snav.plans": "Planes y tarifas",
    "snav.plans.view": "Planes (solo lectura)",
    "snav.users": "Usuarios",
    "snav.session.admin": "Admin Support",
    "snav.session.agent": "Agente",

    // Clients page
    "clients.title": "Clientes",
    "clients.new": "Nuevo cliente",
    "clients.searchPlaceholder": "Buscar por nombre, email o dirección...",
    "clients.col.name": "Nombre",
    "clients.col.contact": "Contacto",
    "clients.col.address": "Dirección",
    "clients.col.fee": "Tarifa",
    "clients.col.status": "Estado",
    "clients.empty.title": "Aún no hay clientes",
    "clients.empty.msg": "Comienza agregando tu primer cliente para emitir facturas y rastrear pagos.",
    "clients.action.transfer": "Solicitar traslado",
    "clients.action.disconnect": "Marcar como desconectado",
    "clients.action.reconnect": "Reactivar cliente",
    "clients.deleteConfirm": "¿Eliminar este cliente? Esta acción no se puede deshacer.",

    // Disconnect dialog
    "disconnect.title": "Marcar cliente como desconectado",
    "disconnect.reason": "Motivo de desconexión",
    "disconnect.reasonHint": "Service verá este motivo en su panel.",
    "disconnect.note": "Nota adicional (opcional)",
    "disconnect.submit": "Marcar desconectado",
    "disconnect.success": "Cliente marcado como desconectado. Notificado a Service.",
    "reconnect.confirm": "¿Reactivar a este cliente?",
    "reconnect.success": "Cliente reactivado.",

    // Disconnected page
    "disc.title": "Clientes desconectados",
    "disc.subtitle": "Servicio suspendido. Visible para Service en tiempo real.",
    "disc.empty": "No hay clientes desconectados.",
    "disc.col.client": "Cliente",
    "disc.col.reason": "Motivo",
    "disc.col.since": "Desconectado el",
    "disc.col.by": "Marcado por",
    "disc.actor.financial": "Financial",
    "disc.actor.support": "Service",

    // Dashboard (financial)
    "dash.period.today": "Hoy",
    "dash.period.7d": "7 días",
    "dash.period.30d": "30 días",
    "dash.period.month": "Mes",
    "dash.period.year": "Año",
    "dash.hero.eyebrow": "Posición global",
    "dash.hero.title": "Resumen ejecutivo",
    "dash.hero.subtitle": "Ingresos acumulados y cobranza del periodo seleccionado",
    "dash.hero.totalIngresos": "Ingresos acumulados",
    "dash.hero.totalHint": "Total cobrado desde el inicio. Solo facturas confirmadas por Square.",
    "dash.hero.collected": "Cobros",
    "dash.hero.receivable": "Por cobrar",
    "dash.hero.netBalance": "Balance neto",
    "dash.hero.cobradas": "cobradas",
    "dash.hero.abiertas": "abiertas",
    "dash.kpi.collectionRate": "Tasa de cobro",
    "dash.kpi.periodBalance": "Balance del periodo",
    "dash.kpi.avgTicket": "Ticket promedio",
    "dash.kpi.periodRevenue": "Ingresos del periodo",
    "dash.kpi.invoices": "facturas",
    "dash.kpi.perInvoice": "por factura pagada",
    "dash.kpi.vs": "vs.",
    "dash.kpi.prev": "previo",
    "dash.coll.eyebrow": "Cobranza",
    "dash.coll.title": "Cuentas por cobrar",
    "dash.coll.subtitle": "Facturas vencidas y posición financiera en tiempo real",
    "dash.coll.overduePayments": "Pagos vencidos",
    "dash.coll.goInvoices": "Ir a facturas",
    "dash.coll.empty.title": "Sin pagos vencidos",
    "dash.coll.empty.msg": "Cobranza al día — todas las facturas pendientes están dentro de su periodo de pago.",
    "dash.snap.title": "Snapshot de caja",
    "dash.snap.subtitle": "Posición",
    "dash.snap.totalExp": "Gastos totales",
    "dash.snap.receivable": "Por cobrar (abiertas)",
    "dash.snap.periodRev": "Ingresos del periodo",
    "dash.snap.newClients": "Nuevos clientes",
    "dash.snap.topClient": "Top cliente histórico",
    "dash.email.mock": "Email en modo MOCK",

    // Login
    "login.financial.title": "Acceso de Administrador",
    "login.financial.subtitle": "Panel de gestión financiera",
    "login.support.title": "Acceso de Agente",
    "login.support.subtitle": "Accede a tu panel.",
    "login.unified.title": "Iniciar sesión",
    "login.unified.subtitle": "Acceso al portal (Financiero o Soporte)",
    "login.portal.workspace": "Portal FlexEnergy",
    "login.portal.financial": "Financial Portal",
    "login.portal.support": "Support Portal",
    "login.email": "Email",
    "login.password": "Contraseña",
    "login.submit": "Ingresar",
    "login.submitting": "Ingresando...",
    "login.demo": "Demo · Acceso rápido",
    "login.adminLink": "¿Eres administrador? Iniciar sesión aquí →",
    "login.agentLink": "¿Eres agente? Iniciar sesión aquí →",

    // Invoices
    "inv.title": "Facturas",
    "inv.context": "facturas",
    "inv.new": "Nueva factura",
    "inv.tab.all": "Todas",
    "inv.tab.pending": "Pendientes",
    "inv.tab.paid": "Pagadas",
    "inv.tab.overdue": "Vencidas",
    "inv.col.client": "Cliente",
    "inv.col.description": "Descripción",
    "inv.col.amount": "Monto",
    "inv.col.issue": "Emisión",
    "inv.col.due": "Vencimiento",
    "inv.col.status": "Estado",
    "inv.empty.title": "Aún no hay facturas",
    "inv.empty.msg": "Crea tu primera factura para empezar a cobrar.",
    "inv.action.refund": "Reembolsar",
    "inv.action.markPaid": "Marcar pagada",
    "inv.action.resend": "Reenviar email",
    "inv.action.payLink": "Link de pago",

    // Reports
    "rep.title": "Reportes",
    "rep.subtitle": "Análisis financiero y operacional",

    // Accounting
    "acc.title": "Contabilidad",
    "acc.subtitle": "Ingresos, gastos y conciliación",
  },

  en: {
    "common.cancel": "Cancel",
    "common.save": "Save",
    "common.saving": "Saving...",
    "common.confirm": "Confirm",
    "common.delete": "Delete",
    "common.edit": "Edit",
    "common.search": "Search",
    "common.loading": "Loading...",
    "common.error": "Something went wrong. Try again.",
    "common.empty": "No results",
    "common.workspace": "Workspace",
    "common.actions": "Actions",
    "common.status": "Status",
    "common.reason": "Reason",
    "common.notes": "Notes",
    "common.required": "Required",
    "common.optional": "Optional",
    "common.client": "Client",
    "common.clients": "Clients",
    "common.amount": "Amount",
    "common.date": "Date",
    "common.theme.dark": "Dark mode",
    "common.theme.light": "Light mode",
    "common.language": "Language",

    "brand.financial": "Financial",
    "brand.support": "Support",
    "brand.texas": "Texas · Support",

    "nav.group.general": "General",
    "nav.group.panel": "Panel",
    "nav.group.clients": "Clients",
    "nav.group.operation": "Operations",
    "nav.group.finance": "Finance",
    "nav.group.communication": "Communication",
    "nav.group.system": "System",
    "nav.group.admin": "Administration",
    "nav.group.session": "Session",

    "nav.dashboard": "Dashboard",
    "nav.newConnection": "New connection",
    "nav.clients": "Active clients",
    "nav.clients.pending": "Pending activation",
    "nav.clients.disconnected": "Disconnected clients",
    "nav.clients.reconnect": "Pending reconnection",
    "nav.invoices": "Invoices",
    "nav.calendar": "Calendar",
    "nav.accounting": "Accounting",
    "nav.reports": "Reports",
    "nav.payouts": "Referral payouts",
    "nav.plans": "Plans",
    "nav.communications": "Communication center",
    "nav.activity": "Activity",
    "nav.admins": "Administrators",
    "nav.changePassword": "Change password",
    "nav.logout": "Sign out",

    "pwd.title": "Change password",
    "pwd.current": "Current password",
    "pwd.new": "New password",
    "pwd.confirm": "Confirm new",
    "pwd.hint": "Min 8 characters. Must differ from current.",
    "pwd.mismatch": "Passwords don't match",
    "pwd.tooShort": "Min 8 characters",
    "pwd.success": "Password updated",
    "pwd.submit": "Update",

    "snav.group.operations": "Operations",
    "snav.group.clients": "Clients",
    "snav.group.catalog": "Catalog",
    "snav.group.team": "Team",
    "snav.group.administration": "Administration",
    "snav.orders": "New orders",
    "snav.leads": "Assigned leads",
    "snav.active": "Active",
    "snav.disconnected": "Disconnected",
    "snav.transferred": "Transferred",
    "snav.lost": "Lost leads",
    "snav.plans": "Plans & rates",
    "snav.plans.view": "Plans (view only)",
    "snav.users": "Users",
    "snav.session.admin": "Support Admin",
    "snav.session.agent": "Agent",

    "clients.title": "Clients",
    "clients.new": "New client",
    "clients.searchPlaceholder": "Search by name, email or address...",
    "clients.col.name": "Name",
    "clients.col.contact": "Contact",
    "clients.col.address": "Address",
    "clients.col.fee": "Fee",
    "clients.col.status": "Status",
    "clients.empty.title": "No clients yet",
    "clients.empty.msg": "Add your first client to issue invoices and track payments.",
    "clients.action.transfer": "Request transfer",
    "clients.action.disconnect": "Mark as disconnected",
    "clients.action.reconnect": "Reactivate client",
    "clients.deleteConfirm": "Delete this client? This action cannot be undone.",

    "disconnect.title": "Mark client as disconnected",
    "disconnect.reason": "Disconnection reason",
    "disconnect.reasonHint": "Service will see this reason on their panel.",
    "disconnect.note": "Additional note (optional)",
    "disconnect.submit": "Mark disconnected",
    "disconnect.success": "Client marked as disconnected. Service notified.",
    "reconnect.confirm": "Reactivate this client?",
    "reconnect.success": "Client reactivated.",

    "disc.title": "Disconnected clients",
    "disc.subtitle": "Service suspended. Visible to Service in real time.",
    "disc.empty": "No disconnected clients.",
    "disc.col.client": "Client",
    "disc.col.reason": "Reason",
    "disc.col.since": "Disconnected on",
    "disc.col.by": "Marked by",
    "disc.actor.financial": "Financial",
    "disc.actor.support": "Service",

    "dash.period.today": "Today",
    "dash.period.7d": "7 days",
    "dash.period.30d": "30 days",
    "dash.period.month": "Month",
    "dash.period.year": "Year",
    "dash.hero.eyebrow": "Global position",
    "dash.hero.title": "Executive summary",
    "dash.hero.subtitle": "Accrued revenue and collection for the selected period",
    "dash.hero.totalIngresos": "Accrued revenue",
    "dash.hero.totalHint": "Total collected since inception. Only Square-confirmed invoices.",
    "dash.hero.collected": "Collected",
    "dash.hero.receivable": "Receivable",
    "dash.hero.netBalance": "Net balance",
    "dash.hero.cobradas": "collected",
    "dash.hero.abiertas": "open",
    "dash.kpi.collectionRate": "Collection rate",
    "dash.kpi.periodBalance": "Period balance",
    "dash.kpi.avgTicket": "Avg. ticket",
    "dash.kpi.periodRevenue": "Period revenue",
    "dash.kpi.invoices": "invoices",
    "dash.kpi.perInvoice": "per paid invoice",
    "dash.kpi.vs": "vs.",
    "dash.kpi.prev": "prev",
    "dash.coll.eyebrow": "Collections",
    "dash.coll.title": "Accounts receivable",
    "dash.coll.subtitle": "Overdue invoices and real-time financial position",
    "dash.coll.overduePayments": "Overdue payments",
    "dash.coll.goInvoices": "Go to invoices",
    "dash.coll.empty.title": "No overdue payments",
    "dash.coll.empty.msg": "Collections on track — all pending invoices are within their payment window.",
    "dash.snap.title": "Cash snapshot",
    "dash.snap.subtitle": "Position",
    "dash.snap.totalExp": "Total expenses",
    "dash.snap.receivable": "Receivable (open)",
    "dash.snap.periodRev": "Period revenue",
    "dash.snap.newClients": "New clients",
    "dash.snap.topClient": "Top historical client",
    "dash.email.mock": "Email in MOCK mode",

    "login.financial.title": "Admin sign-in",
    "login.financial.subtitle": "Financial management panel",
    "login.support.title": "Agent sign-in",
    "login.support.subtitle": "Access your panel.",
    "login.unified.title": "Sign in",
    "login.unified.subtitle": "Access the workspace (Financial or Support)",
    "login.portal.workspace": "FlexEnergy Portal",
    "login.portal.financial": "Financial Portal",
    "login.portal.support": "Support Portal",
    "login.email": "Email",
    "login.password": "Password",
    "login.submit": "Sign in",
    "login.submitting": "Signing in...",
    "login.demo": "Demo · Quick access",
    "login.adminLink": "Are you an admin? Sign in here →",
    "login.agentLink": "Are you an agent? Sign in here →",

    "inv.title": "Invoices",
    "inv.context": "invoices",
    "inv.new": "New invoice",
    "inv.tab.all": "All",
    "inv.tab.pending": "Pending",
    "inv.tab.paid": "Paid",
    "inv.tab.overdue": "Overdue",
    "inv.col.client": "Client",
    "inv.col.description": "Description",
    "inv.col.amount": "Amount",
    "inv.col.issue": "Issue date",
    "inv.col.due": "Due date",
    "inv.col.status": "Status",
    "inv.empty.title": "No invoices yet",
    "inv.empty.msg": "Create your first invoice to start collecting.",
    "inv.action.refund": "Refund",
    "inv.action.markPaid": "Mark paid",
    "inv.action.resend": "Resend email",
    "inv.action.payLink": "Payment link",

    "rep.title": "Reports",
    "rep.subtitle": "Financial and operational analytics",

    "acc.title": "Accounting",
    "acc.subtitle": "Income, expenses and reconciliation",
  },
};

// Mapping from disconnect reason codes returned by backend to localized labels.
// The backend always returns the canonical Spanish label; this overlay enables EN.
export const REASON_I18N = {
  non_payment: { es: "Falta de pago", en: "Non-payment" },
  relocation: { es: "Traslado del cliente", en: "Client relocation" },
  customer_request: { es: "Cliente solicitó cancelar", en: "Customer requested cancel" },
  fraud: { es: "Fraude / verificación fallida", en: "Fraud / verification failed" },
  other: { es: "Otro", en: "Other" },
};
